import cx from 'classnames'
import React from 'react'
import { FieldRenderProps } from 'react-final-form'
import { Select } from '@cinch-labs/design-system'

import { Arrow } from '@cinch/oxd-components/icons/src'
import SVG from '@cinch/oxd-components/svg/src'

import * as styles from './select.module.css'

export interface SelectOption {
  label: string
  value: string | number
  selectedLabel?: React.ReactNode
  disabled?: boolean
}

export interface FieldTextProps extends FieldRenderProps, React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string
  options?: SelectOption[]
  selectSize?: 'small' | 'regular'
}

const SelectField: React.FC<FieldTextProps> = ({ label = '', options = [], input, selectSize = 'regular' }) => {
  const selectedOption = options.find((option) => option.value === input.value)

  return (
    <div className={cx(styles.select, { [styles.selectSmall]: selectSize === 'small' })}>
      <label className={styles.label}>{label}</label>
      <div className={styles.valueIcon}>
        <span className={styles.value} data-testid="value">
          {selectedOption ? selectedOption.selectedLabel || selectedOption.label : ''}
        </span>
        <SVG children={Arrow} hasGradient={true} size={22} className={styles.icon} />
      </div>
      <Select
        options={options}
        classNames={{
          select: styles.input,
          option: styles.option,
        }}
        oxford
        {...input}
      />
    </div>
  )
}

export default SelectField
